import { Space } from 'antd'
import { MultiLineSpaceProps } from './types'

/**
 * @see {@link MultiLineSpaceProps}
 */
const MultiLineSpace: React.FC<MultiLineSpaceProps> = ({
  children,
  text,
  size = 'small',
  transformer = (line) => line,
  ...props
}) => {
  const resolved = text ?? children
  if (typeof resolved !== 'string') return null
  return (
    <Space {...props} size={size} direction="vertical">
      {resolved.split('\n').map(transformer)}
    </Space>
  )
}

export default MultiLineSpace
